module.exports = __webpack_public_path__ + "img/Group 97838.122a2d44.png";